export default __webpack_public_path__ + "static/media/home-icon.7b5eac93.svg";